/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { Box } from "@mui/material";
import { getLevelColor, getLevelIcon } from "../levelHelpers";
import AppLink from "./../../AppLink";
import AppSnackbarTemplateModel from "./AppSnackbarTemplateModel";
import AppSnackbarTemplateProps from "./AppSnackbarTemplateProps";

export default function AppSnackbarTemplate(props: AppSnackbarTemplateProps) {
    const vm = new AppSnackbarTemplateModel(props);
    const LevelIcon = getLevelIcon(props.level);
    return (
        <Box sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
            <LevelIcon
                sx={{ color: theme => getLevelColor(theme, props.level) }}
                fontSize="small"
            />
            <div>
                {vm.zeigeTyp && (
                    <>
                        {`${vm.typBezeichnung} `}
                        <AppLink to={vm.typUrl}>{`${vm.typMatchcode}: `}</AppLink>
                    </>
                )}

                {vm.text}
                {" "}
                {vm.zeigeAktion && (
                    <AppLink to={window.location.pathname.indexOf("/buchungsportal") > 0 ? "/buchungsportal" : ""} onClick={vm.aktionKlick}>
                        {vm.aktionText}
                    </AppLink>
                )}
            </div>

        </Box>
    );
}
